import { combineReducers } from "redux";

import requestReducer from './request/request.reducer';
import deactivateReducer from "./deactivate/deactivate.reducer";
import rejectRequestReducer from "./reject-request/reject-request.reducer";

const rootReducer = combineReducers({
    request: requestReducer,
    deactivate: deactivateReducer,
    reject: rejectRequestReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;